import { CopyToClipboard } from '@10xLabs/react-web/components/CopyToClipboard'
import { ReactElement } from 'react'
import { FormattedMessage } from 'react-intl'
import { Link } from 'react-router-dom'
import styled from 'styled-components'

import { StyledLink } from 'components/v2/Link'
import { TableContainer, Table, Thead, Th, Tbody, Tr, Td, TdId, IdWrapper } from 'components/v2/Table'
import { Tag } from 'components/v2/Tag'
import { useLogin } from 'features/Login/hooks'
import { FEATURES } from 'features/Roles/components/Permissions/constants'
import { IRoutingProjectsCollection } from 'features/RoutingProjects/collections'
import { RoutingProjectActions } from 'features/RoutingProjects/components/RoutingProjectsActions'
import { canWrite } from 'features/Users/utils'
import { getShortId } from 'utils/string'
import { Dropdown } from 'components/v2/Dropdown'
import List from 'components/v2/List'

const Tags = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
`

interface IRoutingProjectsListProps {
  routingProjectsCollection: IRoutingProjectsCollection
}

export const RoutingProjectsList = ({ routingProjectsCollection }: IRoutingProjectsListProps): ReactElement => {
  const login = useLogin()
  const { policies } = login.accessToken
  const canSeeActions = canWrite(FEATURES.ROUTE, policies)

  return (
    <div>
      <TableContainer overflow>
        <Table>
          <Thead>
            <Tr>
              {canSeeActions && <Th noUppercase></Th>}
              <Th>
                <FormattedMessage id="routingProjects.list.id" defaultMessage="Project Id" />
              </Th>
              <Th>
                <FormattedMessage id="routingProjects.list.name" defaultMessage="Name" />
              </Th>
              <Th>
                <FormattedMessage id="routingProjects.list.plans" defaultMessage="Plans" />
              </Th>
              <Th>
                <FormattedMessage id="routingProjects.list.tags" defaultMessage="Tags" />
              </Th>
            </Tr>
          </Thead>
          <Tbody>
            {routingProjectsCollection.items.map((routingProject) => {
              return (
                <Tr key={routingProject.id}>
                  {canSeeActions && (
                    <Td>
                      <RoutingProjectActions routingProject={routingProject} />
                    </Td>
                  )}
                  <TdId>
                    <IdWrapper>
                      <StyledLink as={Link} to={`/routing-projects/${routingProject.id}`}>
                        {getShortId(routingProject.id).toUpperCase()}
                      </StyledLink>
                      <CopyToClipboard str={routingProject.id} />
                    </IdWrapper>
                  </TdId>
                  <Td>{routingProject.name}</Td>
                  <Td>
                    {!routingProject.plans.isEmpty ? (
                      <Dropdown toggle={<StyledLink>{routingProject.plans.length}</StyledLink>} noPadding>
                        <List.Container>
                          {routingProject.plans.items.map((plan): ReactElement => {
                            return <List.Item key={plan.id}>{plan.name}</List.Item>
                          })}
                        </List.Container>
                      </Dropdown>
                    ) : (
                      0
                    )}
                  </Td>
                  <Td>
                    <Tags>
                      {routingProject.tags.map((tag) => {
                        return <Tag key={tag}>{tag}</Tag>
                      })}
                    </Tags>
                  </Td>
                </Tr>
              )
            })}
          </Tbody>
        </Table>
      </TableContainer>
    </div>
  )
}
